import identity from "lodash/fp/identity";

class RouteEditPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return identity(data);
  }
}

export default RouteEditPageTransform;



// WEBPACK FOOTER //
// ./src/pages/routeEdit/routeEdit.transforms.js